const initialState = {
  AllReports: [],
  csvAssetsReports: [],
}
const ReportsReducer = (state = initialState, action: { type: any; payload: any; }) => {
  switch (action.type) {
    case 'STORE_REPORTS':
          return {
              ...state,
              AllReports: action.payload,
          };
    case 'STORE_ASSETS_CSV_REPORT':
          return {
              ...state,
              csvAssetsReports: action.payload,
          };
    case 'UPDATE_ASSETS_CSV_REPORT_STATUS':
          return {
              ...state,
              csvAssetsReports: state.csvAssetsReports.map((report: any) => 
                  report.id === action.payload.id ? { ...report, isActive: action.payload.isActive } : report
              )
          };
      default:
          return state;
  }
}

export default ReportsReducer;
